import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};
type ReturnTuple = [vp.GeoLocationResponse | undefined, () => void, () => void];
function useFetchGeolocation({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [response, setResponse] = useState<vp.GeoLocationResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      try {
        const res = await api.fetchGeolocation(source);
        setResponse(res);
      } catch (e) {
        setResponse({
          ip: '',
          city: '',
          region: '',
          country: '',
          loc: '',
          org: '',
          postal: '',
          timezone: '',
        });
      } finally {
        setSendRequest(false);
        setDataFetchingInfo(false);
        return () => {};
      }
    };
    if (shouldSendRequest) sendRequest();
    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);
  return [
    response,
    () => {
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchGeolocation);
